export default __webpack_public_path__ + "static/media/sticker-s.dfd3c845.png";